import React from 'react'
import { useSelector } from 'react-redux'

import { useGetCampaignsQuery } from '../../../api/rtkQueryApi/platform/campaignsApi'
import { RootState } from '../../../app/rootReducer'
import { AgencyV2ClientPageLayout } from '../../../components/layouts/AgencyV2ClientPageLayout'
import { useWhiteLabel } from '../../../whiteLabel/WhiteLabelContext'
import CampaignsList from './CampaignsList'

export const AgencyV2ListCampaignsPage = () => {
  const whiteLabel = useWhiteLabel()
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const campaignsQuery = useGetCampaignsQuery(
    { accountId: currentAccount?.id ?? '', isAgency: whiteLabel?.isAgencies() },
    {
      skip: !currentAccount?.id
    }
  )

  return (
    <AgencyV2ClientPageLayout helmetTitle={'Solo Campaigns'} headerTitle={`Solo Campaigns: ${currentAccount?.name}`} isLoading={!currentAccount}>
      <CampaignsList campaigns={campaignsQuery.data ?? []} isLoading={campaignsQuery.isFetching} enableCreateCampaign createCampaignText={'Create Solo Campaign'} />
    </AgencyV2ClientPageLayout>
  )
}
